import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';
import cn from 'classnames';

import Account from '../Account/Account';
import {
  Table,
  Member,
  DateTime,
  TableCell,
  Button,
  SidebarShowError
} from 'components/common/Elements/Elements';

import { renameMacOS } from 'utils/common';

import classes from './VersionsActivityLogTable.module.scss';

const TableRow = ({
  company,
  tableConf,
  row,
  mouseEnter,
  onOpenAdditionalModal
}) => {
  const createMember = company => {
    return {
      fullName: company.updatedByName,
      description: company.updatedByEmail,
      initials: company.updatedByName
        .split(' ')
        .map(x => x.charAt(0))
        .join('')
        .substr(0, 2)
        .toUpperCase()
    };
  };

  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          classes: classes
        };

        return (
          <Fragment key={`${field}-${company.email}}`}>
            {show && field === 'filename' && (
              <TableCell cellProps={cellProps}>
                {company.filename ? company.filename : 'NA'}
              </TableCell>
            )}
            {show && field === 'action' && (
              <TableCell cellProps={cellProps}>{company.action}</TableCell>
            )}
            {show && field === 'companyName' && (
              <TableCell
                cellProps={cellProps}
                classNameContent={cn(
                  (company.customerId === '-' ||
                    company.customerId === 'NA' ||
                    company.customerId === 'all_tenants') &&
                    classes.specificCustomer
                )}
              >
                {company.customerId === '-' || company.customerId === 'NA' ? (
                  'NA'
                ) : company.customerId === 'all_tenants' ? (
                  'All Tenants'
                ) : (
                  <Account data={company} />
                )}
              </TableCell>
            )}
            {show && field === 'platform' && (
              <TableCell cellProps={cellProps}>
                {renameMacOS(company.platform)}
              </TableCell>
            )}
            {show && field === 'oldVersion' && (
              <TableCell cellProps={cellProps}>{company.oldVersion}</TableCell>
            )}
            {show && field === 'newVersion' && (
              <TableCell cellProps={cellProps}>{company.newVersion}</TableCell>
            )}
            {show && field === 'updatedByName' && (
              <TableCell
                cellProps={cellProps}
                classNameContent={classes.center}
              >
                <Member member={createMember(company)} />
              </TableCell>
            )}
            {show && field === '_created_at' && (
              <TableCell
                cellProps={cellProps}
                classNameContent={classes.center}
              >
                <DateTime date={company._created_at} time />
              </TableCell>
            )}
            {show && field === 'status' && (
              <TableCell
                cellProps={cellProps}
                classNameContent={cn(
                  classes.center,
                  company.status === 'Success'
                    ? classes.color_success
                    : classes.color_error
                )}
              >
                {company.status === 'Success' ? (
                  company.status
                ) : company.errorMessage ? (
                  <div>
                    {'Error'}{' '}
                    <Button
                      className={classes.more}
                      onClick={() =>
                        onOpenAdditionalModal({
                          content: (
                            <SidebarShowError data={company.errorMessage} />
                          )
                        })
                      }
                    >
                      more...
                    </Button>
                  </div>
                ) : (
                  'Error'
                )}
              </TableCell>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func,
  handleCheckCustomer: PropTypes.func,
  CheckBox: PropTypes.func,
  onOpenAdditionalModal: PropTypes.func.isRequired
};

export default TableRow;
